import React from "react";

import Skeleton from "@mui/material/Skeleton";
import MDBox from "components/MDBox";
import { Card } from "@mui/material";

export default function ReelsLoader() {
  return (
    <MDBox
      sx={{
        borderRadius: "25px",
      }}
    >
      <Card sx={{ borderRadius: "25px" }}>
        <MDBox
          sx={{
            height: "600px",
            borderRadius: "25px",
          }}
        >
          <Skeleton
            sx={{
              borderRadius: "25px",
              bgcolor: "grey.900",
            }}
            variant="rounded"
            height="100%"
          />
        </MDBox>
      </Card>
    </MDBox>
  );
}
